export const SET_STATUS="app/assetTypes/SET_STATUS"
export const NEXT_PAGE="app/assetTypes/NEXT_PAGE"
export const BACK_PAGE="app/assetTypes/BACK_PAGE"
export const RESET_PAGE="app/assetTypes/RESET_PAGE"
export const ASSETTYPES_LOADING="app/assetTypes/ASSETTYPES_LOADING"
export const SET_SEARCH="app/assetTypes/SET_SEARCH"
export const SET_SEARCH_VIEW="app/assetTypes/SET_SEARCH_VIEW"
